import { useEffect, useRef, useState } from "react";

interface VisibleElement {
  [key: string]: boolean;
}

export default function WhyDevananta() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState<VisibleElement>({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible({ main: true });
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative w-full pt-12 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6">
        <p
          className={`text-white/50 text-xl font-light mb-8 tracking-widest transition-all duration-700 ${
            visible.main ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          WHY DEVANANTA R&D
        </p>

        <div className="grid md:grid-cols-2 gap-10 items-start">
          <div>
            <h2
              className={`text-white text-4xl md:text-5xl font-light leading-tight mb-12 transition-all duration-700 ${
                visible.main ? "animate-fade-in-up" : "opacity-0"
              }`}
            >
              Redefining Innovation: <br/>A New Era of Advanced Manufacturing
            </h2>
          </div>

          <div
            className={`text-white/70 text-base font-light leading-relaxed space-y-6 transition-all duration-700 ${
              visible.main ? "animate-slide-in-right" : "opacity-0"
            }`}
          >
            <p>
              At DEVANANTA R&D, we're not just building products, we're shaping
              the future of energy, sustainability, and space technologies
              through the power of advanced materials and intelligent design.
            </p>
            <p>
              Rooted in deep scientific expertise and driven by a passion for
              impact, our company thrives at the intersection of innovation,
              precision, and purpose. From advanced battery technologies and
              AI-integrated systems and circular economy solutions, everything
              we create is designed to solve real-world challenges with
              visionary thinking.
            </p>
            <a
              href="/about"
              className="inline-flex items-center gap-3 text-white/60 hover:text-white transition-colors text-sm font-light mt-8"
            >
              <span>READ MORE</span>
              <span>→</span>
            </a>
          </div>
        </div>
      </div>

      <div
        className={`transition-all duration-700 ${
          visible.main ? "animate-fade-in-up" : "opacity-0"
        }`}
      >
        <img
          src="/whydevanantaimage.avif"
          alt="DEVANANTA R&D Advanced Manufacturing Facility"
          className="w-full h-[500px] object-cover rounded-lg"
        />
      </div>
    </section>
  );
}
